import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets.app/images/no-results.svg'


const _hoisted_1 = { class: "no-results-found" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "no-results-found__content" }
const _hoisted_4 = { class: "no-results-found__content-c" }
const _hoisted_5 = { class: "no-results-found__text" }

import Layout from '@/app/components/Layout.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'Page404',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(Layout, null, {
    default: _withCtx(() => [
      _cache[5] || (_cache[5] = _createElementVNode("section", { class: "filter-box filter-box--highlights" }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("img", {
                class: "no-results-found__img",
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "no-results-found__title" }, "Page not found...", -1)),
              _createElementVNode("p", _hoisted_5, [
                _cache[1] || (_cache[1] = _createTextVNode(" Page not found, but you can find some books and pages ", -1)),
                _createVNode(_component_router_link, {
                  to: { name: 'books' },
                  class: "no-results-found__link"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("here", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createVNode(_component_router_link, { to: { name: 'books' } }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("-- Open books ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})